import React from "react";
import { createRoot } from "react-dom/client";
import { Home } from "../../src/js/configurator-react/Home";

const root = createRoot(document.getElementById("app"));
root.render(<Home />);
